// extracted by mini-css-extract-plugin
export var acitonButtons = "_fv-0";
export var additionalIcon = "_fv-f";
export var block = "_fv-1";
export var blockContent = "_fv-7";
export var blockDescription = "_fv-8";
export var blockIcon = "_fv-9";
export var blockTitle = "_fv-6";
export var border = "_fv-a";
export var center = "_fv-l";
export var edge = "_fv-b";
export var edgeLabel = "_fv-c";
export var edgePath = "_fv-d";
export var error = "_fv-e";
export var flowchart = "_fv-g";
export var flowchartContent = "_fv-h";
export var highlighted = "_fv-3";
export var hover = "_fv-4";
export var icon = "_fv-i";
export var left = "_fv-m";
export var navButton = "_fv-j";
export var navButtons = "_fv-k";
export var right = "_fv-n";
export var selected = "_fv-2";
export var small = "_fv-5";